import { render, staticRenderFns } from "./TableCombos.vue?vue&type=template&id=a8655790"
import script from "./TableCombos.vue?vue&type=script&lang=js"
export * from "./TableCombos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports